import React from 'react';

// Entry Point Card Component
const EntryPointCard = ({ selected, onClick, icon: Icon, title, description }) => (
    <button
        onClick={onClick}
        className={`w-full p-4 rounded-xl border-2 text-left transition-all duration-200 ${selected
            ? 'border-orange-400 bg-orange-50/50 shadow-sm'
            : 'border-stone-200 bg-white hover:border-stone-300'
            }`}
    >
        <div className="flex items-start gap-3">
            <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 mt-0.5 ${selected ? 'border-orange-500' : 'border-stone-300'
                }`}>
                {selected && <div className="w-2.5 h-2.5 rounded-full bg-orange-500" />}
            </div>
            <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                    <Icon className={`w-4 h-4 ${selected ? 'text-stone-700' : 'text-stone-500'}`} />
                    <span className={`text-sm font-semibold ${selected ? 'text-stone-800' : 'text-stone-700'}`}>
                        {title}
                    </span>
                </div>
                <p className="text-xs text-stone-500 leading-relaxed">
                    {description}
                </p>
            </div>
        </div>
    </button>
);

export default EntryPointCard;
